<template>
    <div>
        <!-- <crud-table :actions="actions" show-search search-placeholder="ابحث باسم الدورة" server-pagination :page-count="courses.meta.last_page" :current-page="courses.meta.current_page" :total="courses.meta.total" :per-page="courses.meta.per_page" title="الدورات" :items="coursesItemsComputed" :headers="headers" @edit="openEditDialog" @delete="openDeleteDialog" @load="loadMore" @create="createDialog =  true" @search="search" @hide="openHideDialog" @unhide="openUnhideDialog" @feature="openFeatureDialog" @unfeature="openUnfeatureDialog" @reset="reset" /> -->
        <v-card class="soft-shadow pa-lg-3">
            <v-card-text class="pb-0 pa-3">
                <div class="d-flex flex-column flex-lg-row">
                    <div class="me-lg-9 mb-4 mb-lg-0">
                        <v-img style="border-radius: 5px" :src="courseData.image_url" :width="phoneOnly ? '100%' : 210" :height="phoneOnly ? 180 : 140" > <!-- class="e-link" v-ripple="{class: 'white--text'}" @click="avatarDialog = true" -->
                            <!-- <v-btn fab x-small dark color="primary" top right background-color="primary" class="ma-2" @click.stop="avatarDialog = true" @touchstart.stop @mousedown.stop>
                                <v-icon size="18" color="white">mdi-image-edit-outline</v-icon>
                            </v-btn> -->
                        </v-img>
                    </div>
                    <div class="pa-1">
                        <div class="mb-4 mb-lg-3">
                            <h1 class="strong-text--text font-weight-medium" style="line-height: 1!important" :class="{'text-center': phoneOnly}">{{courseData.name}}</h1>
                        </div>
                        <div class="badges d-flex justify-center justify-lg-start mb-6">
                            <div>
                                <v-chip v-for="category in courseData.categories" small label :key="'category-' + category.id" class="font-weight-medium px-2 pe-4 me-2">
                                    <v-icon size="18" class="me-2">mdi-tag</v-icon>
                                    <span>{{category.name}}</span>
                                </v-chip>
                            </div>
                            <div>
                                <v-chip v-if="courseData.featured" label small color="orange darken-1" dark class="px-2 me-2">
                                    <v-icon size="16" class="me-2">mdi-star</v-icon>
                                    <span>مميز</span>
                                </v-chip>

                                <v-chip v-if="courseData.is_hidden" label small color="text" dark class="px-2 me-2" @click="unhideDialog = true">
                                    <v-icon size="16" class="me-2">mdi-eye-off</v-icon>
                                    <span>مخفي</span>
                                </v-chip>

                                <v-chip v-if="courseData.visibility === 'default'" label small color="blue-grey" dark class="px-2 me-2" @click="hideDialog = true">
                                    <v-icon size="16" class="me-2">mdi-eye</v-icon>
                                    <span>افتراضي</span>
                                </v-chip>
                            </div>
                        </div>
                        <p class="medium-text" style="line-height: 1.65rem; white-space: pre-line;">{{courseData.description}}</p>
                        <div>
                            <v-btn v-if="courseData.pay_type === 'lectures'" :to="`/purchases/lectures?query=course:${id}`" depressed color="green darken-2" dark class="me-2">
                                <v-icon left>mdi-order-bool-descending-variant</v-icon>
                                <span>عرض عمليات الشراء</span>
                            </v-btn>

                            <v-btn depressed color="green darken-3" outlined @click="exportAbsentReportDialog = true;" class="me-2">
                                <v-icon left>mdi-file-export</v-icon>
                                <span>استخراج تقرير الغياب</span>
                            </v-btn>

                            <v-btn v-if="courseData.pay_type === 'lectures'" depressed color="primary" outlined @click="exportUsersDialog = true;" class="me-2">
                                <v-icon left>mdi-account-multiple</v-icon>
                                <span>استخراج الطلاب</span>
                            </v-btn>
                        </div>
                    </div>
                </div>
                <!-- <v-divider class="my-3"></v-divider> -->
            </v-card-text>
        </v-card>

        <v-card class="soft-shadow pb-3 px-lg-2 my-4">
            <v-card-title class="medium-title">
                <v-icon class="me-2">mdi-chart-timeline-variant-shimmer</v-icon>
                <span>اﻹحصائيات واﻷرقام</span>
            </v-card-title>
            <!-- <v-card-subtitle>إحصائيات وأرقام لنتائج تحليل بيانات الدورة</v-card-subtitle> -->
            <v-card-text class="py-2">
                <v-row>
                    <v-col cols="12" lg="4">
                        <stat-card label="الطلاب المشتركون" flat :value="courseData.users_count" color="primary" icon="mdi-account-group"/>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <stat-card label="المحاضرات" flat :value="courseData.lectures_count" color="deep-purple" icon="mdi-human-male-board"/>
                    </v-col>
                    <v-col cols="12" lg="4">
                        <stat-card label="الفيديوهات" flat :value="courseData.videos_count" color="deep-orange" icon="mdi-motion-play"/>
                    </v-col>
                    <template v-if="courseData.pay_type === 'course'">
                        <v-col cols="12" lg="6">
                            <stat-card label="عمليات الشراء" flat :value="courseData.purchases_count" color="success" icon="mdi-order-bool-descending-variant"/>
                        </v-col>
                        <!-- <v-col cols="12" lg="6">
                            <stat-card label="المبيعات" money flat :value="courseData.sales" color="orange" icon="mdi-cash-multiple"/>
                        </v-col> -->
                    </template>
                </v-row>
            </v-card-text>
        </v-card>

        <!-- <v-card class="soft-shadow pa-3 pt-0 mb-4">
            <v-card-title>اﻹحصائيات</v-card-title>
            <v-card-subtitle>إحصائيات وأرقام استُنتجت من تحليل بيانات الدورة</v-card-subtitle>
            <v-card-text>

            </v-card-text>
        </v-card> -->

        <lectures :lectures="lectures" :course="courseData" :page_url="page_url" :course_id="id" :default-price="courseData.lecture_price" @loadMore="loadMore" />

        <div v-if="purchases && purchases.data && purchases.data.length && courseData.pay_type === 'course'" class="my-4">
            <purchases-table :purchases="{data: coursePurchases}" title="آخر عمليات الشراء" title-icon="mdi-order-bool-descending-variant" :all-href="`/purchases/courses?query=course:${id}`" >
                <template slot="header-actions">
                    <template v-if="courseData.pay_type === 'course'">
                        <v-btn depressed color="success" class="px-4" @click="addPurchaseDialog = true">
                            <v-icon :left="pcOnly">mdi-account-plus</v-icon>
                            <span v-if="pcOnly">إضافة عملية شراء</span>
                        </v-btn>
                    </template>
                </template>
            </purchases-table>
        </div>


        <!-- <v-card class="soft-shadow pa-3 pt-0 my-4">
            <v-card-title>الطُلاب المشتركون</v-card-title>
            <v-card-subtitle>الطلاب الذين قاموا بالاشتراك في الدورة وتظهر لديهم في "دوراتي"</v-card-subtitle>
            <v-card-text>
                <v-list v-if="courseData.users" two-line class="pa-0 transparent" max-width="400">
                    <template v-for="(user, i) in courseData.users">
                        <inertia-link as="v-list-item" :key="user.id" :href="`/users/${user.id}`">
                            <v-list-item-avatar>
                                <v-img :src="user.avatar"></v-img>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{user.name}}</v-list-item-title>
                                <v-list-item-subtitle>مشترك</v-list-item-subtitle>
                            </v-list-item-content>
                        </inertia-link>
                        <v-divider v-if="i < courseData.users.length - 1" :key="'divider-' + user.id"></v-divider>
                    </template>
                </v-list>
            </v-card-text>
        </v-card> -->

        <div class="actions">
            <action-dialog v-model="addPurchaseDialog" action="post" :url="`/courses/${id}/purchases`" success-msg="تم إضافة عملية الشراء بنجاح" title="إضافة عملية شراء للدورة" subtitle="إضافة الدورة إلى مشتريات طالب مباشرة" button-text="إضافة" button-color="success darken-1" :data="addPurchaseForm" @reset="resetPurchaseForm" @sync="addToPurchases">
                <v-text-field v-model="addPurchaseForm.user" color="success darken-1" prepend-inner-icon="mdi-account-circle" label="حساب الطالب" placeholder="أدخل معرف الطالب أو البريد الإلكتروني"></v-text-field>
                <v-text-field v-model="addPurchaseForm.paid_value" color="success darken-1" prepend-inner-icon="mdi-cash" label="المبلغ المدفوع" placeholder="المبلغ الذي دفعه الطالب"></v-text-field>
            </action-dialog>

            <action-dialog v-model="hideDialog" action="put" :url="`/courses/${id}`" :data="{is_hidden: true}" title="إخفاء الدورة" button-text="تأكيد اﻹخفاء" button-color="black" @sync="sync">
                <div class="strong-text--text">
                    هل أنت متأكد من إخفاء الدورة <b class="strong-text--text">"{{courseData.name}}"</b> ؟
                </div>
            </action-dialog>

            <action-dialog v-model="unhideDialog" action="put" :url="`/courses/${id}`" :data="{is_hidden: false}" title="إظهار الدورة" button-text="تأكيد اﻹظهار" button-color="primary" @sync="sync">
                <div class="strong-text--text">
                    هل أنت متأكد من إلغاء إخفاء الدورة <b class="strong-text--text">"{{courseData.name}}"</b> ؟
                </div>
            </action-dialog>

            <action-dialog v-model="avatarDialog" action="post" :url="`/courses/${id}/image`" :as-form-data="true" :data="{imageFile: newImageFile}" title="تغيير الصورة المصغرة" subtitle="قم باختيار الصورة المصغرة الجديدة للدورة" button-text="حفظ" button-color="primary" @sync="sync" @reset="newImageFile = null">
                <v-file-input v-model="newImageFile" ref="imageInput" accept="image/png, image/jpeg" placeholder="اختر صورة" prepend-icon="" prepend-inner-icon="mdi-image" label="الصورة المصغرة *" ></v-file-input>
            </action-dialog>


            <action-dialog v-model="exportAbsentReportDialog" action="post" :url="`/courses/${id}/absent/export`" :data="{type: courseData.pay_type === 'course' ? 'views' : exportAbsentType}" success-msg="تم تنفيذ عملية الاستخراج، سيظهر الملف في صفحة الملفات المستخرجة بعد قليل" title="استخراج تقرير الغياب" subtitle="استخراج تقرير غياب الطلاب إلى ملف إكسيل" button-text="استخراج" button-color="success" max-width="320">
                <v-select v-if="courseData.pay_type === 'lectures'" v-model="exportAbsentType" name="type" outlined label="نوع التقرير" :items="[{text: 'تقرير الغياب حسب الشراء', value: 'purchases'}, {text: 'تقرير الغياب حسب المشاهدات', value: 'views'}]"></v-select>
            </action-dialog>

            <v-dialog v-if="courseData.pay_type === 'lectures'" v-model="exportUsersDialog" max-width="320" overlay-color="#000" overlay-opacity="0.8">
                <v-card>
                    <v-card-title class="strong-text--text mb-1">
                        <v-icon color="green darken-2" right>mdi-file-export-outline</v-icon>
                        استخراج الطلاب المنضمين
                    </v-card-title>
                    <v-card-subtitle>استخراج بيانات الطلاب المنضمين للدورة إلى ملف إكسيل</v-card-subtitle>
                    <v-card-text>
                        <!-- <v-form class="mb-4">
                            <v-checkbox v-model="exportUserFullData" color="success" label="استخراج بيانات الطالب كاملة" persistent-hint hint="استخراج بيانات الطالب كاملةً وليس الاسم فقط" class="mt-0"></v-checkbox>
                        </v-form> -->
                    </v-card-text>
                    <v-card-actions class="pt-0 pb-3">
                        <form method="POST" :action="`${apiUrl}/courses/${id}/users/export`" class="w-100">
                            <input type="hidden" name="api_token" :value="apiToken" />

                            <v-btn type="submit" block color="green darken-1" depressed dark download @click="exportUsersDialog = false">
                                <v-icon left>mdi-download</v-icon>
                                استخراج الملف
                            </v-btn>
                        </form>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import CrudTable from '@/components/default/crud-table'
import StatCard from '@/components/default/stat-card'

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'
import Lectures from './Lectures'
import PurchasesTable from '@/components/custom/purchases-table'

export default {
    components: {
        CrudTable,
        StatCard,
        Lectures,
        PurchasesTable
    },
    props: {
        course: {},
        lectures: {},
        purchases: {},
    },
    data() {
        return {
            courseData: null,

            exportAbsentReportDialog: false,
            exportAbsentType: 'purchases',
            
            exportUsersDialog: false,

            coursePurchases: null,
            
            addPurchaseDialog: false,
            addPurchaseForm: {
                user: '',
                paid_value: '',
            },

            avatarDialog: false,
            newImageFile: null,

            hideDialog: false,
            unhideDialog: false,
        }
    },
    computed: {
        apiUrl(){
            return process.env.VUE_APP_API_URL;
        },
        apiToken(){
            return window.localStorage.getItem('tK');
        },
        id(){
            return this.courseData.id;
        },
        page_url(){
            return '/courses/' + this.courseData.id;
        },
        ...GlobalComputed,
    },
    watch: {

    },
    methods: {
        ...GlobalMethods,
        sync(data){
            Object.assign(this.courseData, data);
        },
        resetPurchaseForm(){
            Object.assign(this.addPurchaseForm, {
                user: '',
            });
        },
        addToPurchases(purchase){
            this.coursePurchases.unshift(purchase);
        },
        loadMore(page){
            this.$emit('loadMore', page);
        }
    },
    created(){
        this.courseData = this.course.data;
        this.coursePurchases = this.purchases && this.purchases.data ? this.purchases.data : [];
    }
}

</script>
